import { useState, type ReactNode } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

interface Props {
  title: string;
  subtitle?: ReactNode;
  rightSlot?: ReactNode;
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  children: ReactNode;
}

export function CollapsibleSection({ title, subtitle, rightSlot, open: controlledOpen, defaultOpen = false, onOpenChange, children }: Props) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;

  function toggle() {
    const next = !open;
    if (isControlled) {
      onOpenChange?.(next);
    } else {
      setInternalOpen(next);
      onOpenChange?.(next);
    }
  }

  return (
    <div className="rounded-xl border border-neutral-200 bg-white overflow-hidden">
      <button
        type="button"
        onClick={toggle}
        className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left hover:bg-neutral-50 transition-colors"
      >
        <div className="flex items-baseline gap-3 flex-1 min-w-0">
          <span className="text-base font-semibold text-neutral-900">{title}</span>
          {subtitle && <span className="text-xs text-neutral-500 truncate">{subtitle}</span>}
        </div>
        <div className="flex items-center gap-3 shrink-0">
          {rightSlot}
          {open ? <ChevronUp size={16} className="text-neutral-400" /> : <ChevronDown size={16} className="text-neutral-400" />}
        </div>
      </button>
      {open && (
        <div className="px-5 pb-5 pt-0 border-t border-neutral-200">
          {children}
        </div>
      )}
    </div>
  );
}
